import { render } from "./MyThanksView.vue?vue&type=template&id=73f3a024"
import script from "./MyThanksView.vue?vue&type=script&lang=js"
export * from "./MyThanksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__